/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { viastoriaControllerIngestStream } from '../fn/viastoria/viastoria-controller-ingest-stream';
import { ViastoriaControllerIngestStream$Params } from '../fn/viastoria/viastoria-controller-ingest-stream';
import { ViastoriaIngestResultDto } from '../models/viastoria-ingest-result-dto';

@Injectable({ providedIn: 'root' })
export class ViastoriaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `viastoriaControllerIngestStream()` */
  static readonly ViastoriaControllerIngestStreamPath = '/integrations/viastoria/stream_ingest';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `viastoriaControllerIngestStream()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  viastoriaControllerIngestStream$Response(params: ViastoriaControllerIngestStream$Params, context?: HttpContext): Observable<StrictHttpResponse<ViastoriaIngestResultDto>> {
    return viastoriaControllerIngestStream(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `viastoriaControllerIngestStream$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  viastoriaControllerIngestStream(params: ViastoriaControllerIngestStream$Params, context?: HttpContext): Observable<ViastoriaIngestResultDto> {
    return this.viastoriaControllerIngestStream$Response(params, context).pipe(
      map((r: StrictHttpResponse<ViastoriaIngestResultDto>): ViastoriaIngestResultDto => r.body)
    );
  }

}
